import request from "@/utils/request";
// 新增联系人
export function addContactPerson(data) {
  return request({
    url: "daily/contact_person/add",
    method: "post",
    data
  });
}
// 提交日报
export function submitDailyPaper(data) {
  return request({
    url: "daily/daily_paper/submitDailyPaper",
    method: "post",
    data
  });
}
// 编辑日报
export function editDailyPaper(data) {
  return request({
    url: "daily/daily_paper/editDailyPaper/id/" + data.id,
    method: "post",
    data
  });
}
// 获取日报列表
export function getMylist(params) {
  return request({
    url: "daily/daily_paper/getMylist",
    method: "get",
    params
  });
}
// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: "user/getInfo",
    method: "get",
    params
  });
}
// 获取部门列表
export function getDepartmentList(params) {
  return request({
    url: "common/getDepartmentList",
    method: "get",
    params
  });
}
// 绑定部门
export function profileUser(data) {
  return request({
    url: "user/profile",
    method: "post",
    data
  });
}
// 我的联系人
export function getContactPersonList(params) {
  return request({
    url: "daily/contact_person/index",
    method: "get",
    params
  });
}
// 日报日统计
export function getDailyData(params) {
  return request({
    url: "daily/statistics/getDailyData",
    method: "get",
    params
  });
}
// 日报月统计
export function getMonthData(params) {
  return request({
    url: "daily/statistics/getMonthData",
    method: "get",
    params
  });
}
// 获取日报详情
export function getDateInfo(params) {
  return request({
    url: "daily/daily_paper/getDateInfo",
    method: "get",
    params
  });
}
// 删除日报
export function delDaily(params) {
  return request({
    url: "daily/daily_paper/del/id/" + params.id,
    method: "get",
  });
}
// 
export function getMylistShare(params) {
  return request({
    url: "daily/daily_paper/getMylistShare",
    method: "get",
    params
  });
}
export function getWxSignature(data) {
  return request({
    url: "common/getWxSignature",
    method: "post",
    data
  });
}
export function getShareToken(params) {
  return request({
    url: "daily/daily_paper/getShareToken",
    method: "get",
    params
  });
}
export function getMonthDataList(params) {
  return request({
    url: "daily/statistics/getMonthDataList",
    method: "get",
    params
  });
}
export function addWeekPaper(data) {
  return request({
    url: "daily/daily_paper/weekPaper",
    method: "post",
    data
  });
}
export function getMyWeekPaper(params) {
  return request({
    url: "daily/daily_paper/myWeekPaper",
    method: "get",
    params
  });
}
// 获取工作日
export function getPaperDateArr(params) {
  return request({
    url: "daily/daily_paper/getPaperDateArr",
    method: "get",
    params
  });
}

// 添加考勤
export function submitAttendance(data) {
  return request({
    url: "daily/daily_paper/submitAttendance",
    method: "post",
    data
  });
}
export function getAttendanceList(params) {
  return request({
    url: "daily/daily_paper/getAttendanceList",
    method: "get",
    params
  });
}
export function getAttendanceStatus(params) {
  return request({
    url: "common/getAttendanceStatus",
    method: "get",
    params
  });
}
